module.exports = __webpack_public_path__ + "static/media/iphone.b5cfb6e9.svg";